export class FireworksModel {
    logo!: string
}
export class NotificationAdModel {
    title!: string;
    message?: string;
    logo?: string
}
export class SponsoredByAdModel {
    logos: string[] = [];
}